/**
 * Company: AltSolution
 * Author: Ivan Horobets
 */

"use strict";
if($('.promo_page').length) {
    const LANGUAGE = document.getElementsByTagName('html')[0].getAttribute('lang');

    //Load more
    $('a.load-more').on('click', function (e) {
        e.preventDefault();

        if($(this).hasClass('button--preload-sending')) return false;
        $(this).addClass('button--preload-sending');

        $.ajax({
            type: "GET",
            url: $(this).data('url'),
            processData: false,
            contentType: false,
        }).done(function (data) {
            $('.promo_article_wrap').append(data);
            $('a.load-more').remove();
        });
    });

    //Get email
    let $subscribePromoF = $('.actions_popup--promo form');
    let $subscribePromoFInit = $subscribePromoF.validate({
        highlight: function (element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function (element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function (form) {
            var formData = new FormData($(form)[0]);
            $(form).find('button[type=submit]').prop('disabled', true);
            $.ajax({
                type: "POST",
                url: '/' + LANGUAGE + '/subscribe',
                processData: false,
                contentType: false,
                data: formData
            }).done(function (data) {
                if (data.success) {
                    $('.actions_popup--promo').fadeOut(200, function () {
                        $('.actions_popup--subscribe').fadeIn(200, function () {
                            $subscribePromoF[0].reset();
                            $subscribePromoFInit.resetForm();
                        });
                    });
                }
            }).always(function() {
                $(form).find('button[type=submit]').prop('disabled', false);
            });
        }
    });
}